import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
export const fieldLayoutContainerStyles = ({ theme }) => css `
	display: flex;
	flex-direction: column;
	gap: ${pxToRem(theme.spacing['100'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
	}
`;
export const FieldLayoutContainer = styled.div `
	${fieldLayoutContainerStyles}
`;
